@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/typography/font-weight";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/box-shadow";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/size";

.section-navigation {
    z-index: 10;
    position: fixed;
    bottom: 0;
    width: 100%;
    transform: translateY(66.66%);
    .desktop-navigation {
        display: none;
    }
    // TODO: remove after live WINS-11189
    .mobile-navigation {
        display: grid;
    }
    @media (min-width: 1024px) {
        position: relative;
        bottom: unset;
        transform: none;
        .desktop-navigation {
            display: flex;
        }
        // TODO: remove after live WINS-11189
        .mobile-navigation {
            display: none;
        }
    }
}

.desktop-navigation {
    position: relative;
    border: border-width.$md solid color.$color-background-400;
    flex-wrap: nowrap;
    gap: 0.2rem;
    background: color.$color-background-400;
    border-radius: border-radius.$xl;
    box-shadow: box-shadow.$md box-shadow.$md color.$color-background-400;
    margin-top: -0.3rem;

    .nav-item {
        flex-grow: 1;
        flex-shrink: 1;
        height: 4.6rem;
        background: color.$color-white;
        white-space: nowrap;
        display: flex;
        justify-content: center;
        align-items: center;
        > * {
            white-space: initial;
        }
        &:first-child {
            border-radius: border-radius.$lg-xl 0 0 border-radius.$lg-xl;
        }
        &:last-child {
            border-radius: 0 border-radius.$lg-xl border-radius.$lg-xl 0;
        }
    }
    .nav-item.link a {
        --text-decoration: none;

        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: color.$color-text;
        text-decoration: none;
        padding: 0 2rem;

        web-icon {
            --icon-height: #{size.$icon-md};
            --icon-width: #{size.$icon-md};
            margin-bottom: 0.6rem;
        }

        &:hover {
            color: color.$color-primary;
        }
    }

    .nav-item.menu {
        height: 4.6rem;
        position: relative;

        > button {
            all: unset;
            color: color.$color-text;
            cursor: pointer;
            display: flex;
            height: 100%;
            justify-content: center;
            align-items: center;
            width: 100%;
            gap: spacing.$md;
            padding: 0 2rem;
            &:hover {
                color: color.$color-primary;
            }
        }
        [data-menu-button] > * {
            pointer-events: none;
        }

        //Exception for first submenu in Spain
        .sub-menu.exception {
            .desktop-submenu {
                padding-left: spacing.$xxl;
                .columns {
                    padding: 2rem spacing.$xxl 2rem 0;
                    a {
                        white-space: nowrap;
                        padding-right: spacing.$xxxl;
                    }
                }
                aside {
                    border-radius: 0 1rem 1rem 1rem;
                    padding-top: 2rem;
                    padding-bottom: 2rem;
                }
            }
        }

        .sub-menu {
            display: none;
            position: absolute;
            top: 100%;
            z-index: 1;
            border: border-width.$md solid color.$color-primary;
            background: color.$color-white;

            .item-heading {
                border-bottom: border-width.$md solid color.$color-background-200;
                font-weight: font-weight.$bold;
                margin-bottom: spacing.$md;
                padding-bottom: spacing.$md;
            }

            .web-list a {
                grid-template-columns: max-content;
            }

            .desktop-submenu {
                display: grid;
                grid-template-areas:
                    "heading upperright"
                    "columns aside";
                padding-left: spacing.$xxl;

                &::before {
                    content: "";
                    grid-area: upperright;
                    background-color: color.$color-background-200;
                    border-top-right-radius: border-radius.$xl;
                }
                .item-heading {
                    color: color.$color-dark;
                    margin: spacing.$md 0;
                    font-weight: font-weight.$bold;
                }
                .heading {
                    grid-area: heading;
                    text-wrap: nowrap;
                    padding-top: 6rem;
                    padding-right: spacing.$xxl;
                    margin-bottom: spacing.$xxl;
                }
                .columns {
                    grid-area: columns;
                    display: flex;
                    gap: spacing.$xl;
                    padding: 2rem spacing.$xxl 2rem 0;
                }
                .column {
                    flex: 1;
                }
                aside {
                    grid-area: aside;
                    background-color: color.$color-background-200;
                    padding: 2rem spacing.$xxl 6rem spacing.$xxl;
                    border-bottom-right-radius: border-radius.$xl;
                    .item-heading {
                        border-color: color.$color-border-light;
                    }
                    .web-list {
                        --web-list-border-color: #{color.$color-border-light};
                    }
                }
            }

            .desktop-gridmenu {
                padding: spacing.$xl spacing.$xxl;
                display: grid;
                gap: spacing.$xxl;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: min-content;

                .grid-item {
                    min-width: 25rem;

                    &:has(ul) {
                        p {
                            margin-bottom: spacing.$md;
                        }
                    }

                    p {
                        color: color.$color-text;
                        margin-bottom: spacing.$lg;
                        margin-top: spacing.$lg;
                    }
                    web-icon {
                        color: color.$color-text-primary;
                        --icon-height: #{size.$icon-md};
                        --icon-width: #{size.$icon-md};
                    }
                    a.link {
                        --text-decoration: none;
                    }
                }
            }
        }
        &.left {
            .sub-menu {
                border-radius: 0 border-radius.$xl border-radius.$xl border-radius.$xl;
                left: -0.2rem;
            }
        }
        &.right {
            .sub-menu {
                border-radius: border-radius.$xl 0 border-radius.$xl border-radius.$xl;
                right: -0.2rem;
            }
        }
        &.full {
            position: unset; // Position relative to the parent
            .sub-menu {
                border-radius: border-radius.$xl;
                width: calc(100% + 2 * #{spacing.$xxl});
                left: calc(-1 * #{spacing.$xxl});
            }
        }
        &.active {
            > button {
                position: relative;
                z-index: 2;
                color: color.$color-primary;
                fill: color.$color-primary;
                svg {
                    transform: rotate(180deg);
                }
                &::after {
                    content: " ";
                    position: absolute;
                    top: -0.4rem;
                    z-index: -1;
                    height: calc(100% + 0.6rem);
                    width: calc(100% + 0.4rem);
                    background: color.$color-white;
                    border: border-width.$md solid color.$color-primary;
                    border-bottom: none;
                }
            }
            .sub-menu {
                display: block;

                .selected {
                    color: color.$color-primary;
                }
            }
        }
    }
    .nav-item {
        &.selected {
            > button,
            > a {
                color: color.$color-primary;
                fill: color.$color-primary;
            }
        }
    }
}

// TODO: remove after live WINS-11189
.mobile-navigation {
    grid-template-columns: 1fr 1fr 1fr;
    background: color.$color-background-200;
    gap: 0.1rem;
    box-shadow: 0 -0.1rem 0.6rem rgb(0 0 0 / 16%);
    transition: transform 1s;
    #menuIcon {
        display: flex;
    }
    #closeIcon {
        display: none;
    }
    &.open {
        transform: translateY(-66.66%);
        #menuIcon {
            display: none;
        }
        #closeIcon {
            display: flex;
        }
    }

    [data-button-mobile-toggle] > * {
        pointer-events: none;
    }
    .nav-item {
        background: color.$color-white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: spacing.$sm;
        padding: spacing.$lg;
        text-decoration: none;
        font-size: font-size.$xxs;
        #menuIcon,
        #closeIcon {
            flex-direction: column;
            align-items: center;
            gap: spacing.$sm;
        }
        web-icon {
            --icon-height: #{size.$icon-lg};
            --icon-width: #{size.$icon-lg};
            color: color.$color-primary;
        }
        &.active {
            color: color.$color-secondary;
            web-icon {
                color: color.$color-secondary;
            }
        }
    }
}
